/*
 * @Description: 房源租赁列表
 * @Author: 段生华
 * @Date: 2019-05-07 17:20:24
 * @LastEditTime: 2019-07-08 13:36:22
 * @LastEditors: Please set LastEditors
 */

import React from 'react';
import { message} from 'antd';
import PageWrap from '../../../components/PageWrap';
import SuperForm from '../../../components/SuperForm';
import Detail from './Detail';
import TableDOM from '../../../components/Table';
import AuthButton from '../../../components/AuthButton/AuthButton';
import { postFrom, config } from '../../../axios';
import { handleExportParams } from '../../../utils';

export default class Page extends React.Component {
    constructor() {
        super();

        this.state = {
            loading: false, //页面加载中
            params: { //搜索参数
                shortName: '',
                buildingNo: '',
                customerName: '',
                customerPhone: '',
                credentialNumber: '',
                mustPayDate: '',
                roomNo: '',
                pageSize: 10,
            },
            current: 1, //当前页
            tableData: [], //表格数据
            tableLoading: false, //表格加载中
            tableTotal: 0, //表格总数据量
            tableTotalMny: 0, //表格总金额
            showSigningModal: false, //显示签约
            showDetailModal: false, //显示详情
        }
    }

    componentDidMount() {
        this.handleSearch();
    }

    handleSearch = (values = {}) => { //表单搜索/分页
        let { params, current } = this.state;
        let data = {};

        if (values.current) {
            data = Object.assign({}, params, values);
        } else {
            data = Object.assign({}, params, values, { current });
        }
        this.setState({ params: Object.assign({}, params, values), tableLoading: true });

        postFrom({ url: config.API_bill_findPrintReceiptPageList, data }).then(res => {
            this.setState({ current: res.current, tableTotal: res.total, tableData: res.records, tableLoading: false });
        }).catch(err => {
            message.error(err.message || '获取列表失败');
            this.setState({ tableLoading: false });
        });
    }

    handleSigning = (e, msg) => { //签约
        this.setState({ showSigningModal: true });
        this.signingRef.loadPack(msg);
    }

    handleShowDetail = (houseId,cycleIn,customerId,buildingName,roomNo,customerName) => { //显示详情
        this.setState({ showDetailModal: true });
        this.detailRef.loadPackage(houseId,cycleIn,customerId,buildingName,roomNo,customerName);
    }

    render() {
        let {
            loading,
            current,
            tableData,
            tableLoading,
            tableTotal,
            tableTotalMny,
            showDetailModal,
        } = this.state;

        return (
            <PageWrap
                loading={loading}
            >
                <div className="search-wrapper search-wrapper-two" style={{ flexDirection: 'column' }}>
                    <SuperForm
                        onRef={ref => this.superFormRef = ref}
                        data={searchData()}
                        sumbit={this.handleSearch}
                        addParams={'current'}
                    />
                </div>
                <TableDOM
                    columns={columns({ handleSigning: this.handleSigning, handleShowDetail: this.handleShowDetail })}
                    data={tableData}
                    loading={tableLoading}
                    total={tableTotal}
                    totalMny={tableTotalMny}
                    current={current}
                    onChange={this.handleSearch}
                />

                <Detail
                    onRef={ref => this.detailRef = ref}
                    visible={showDetailModal}
                    handleCancel={() => { this.setState({ showDetailModal: false }) }}
                />

            </PageWrap>
        )
    }
}

const searchData = () => {
    let data = [
        {
            tagName: 'Input',
            formConfig: { name: 'shortName' },
            attribute: { placeholder: '请输入商户简称', style: { width: '130px' } },
        },
        {
            tagName: 'MonthPicker',
            formConfig: { name: 'mustPayDate' },
            attribute: { placeholder: '请选择周期月份',type:'month',format:"YYYY-MM", style: { width: "172.7px" } },
        },
        {
            tagName: 'Input',
            formConfig: { name: 'customerName' },
            attribute: { placeholder: '请输入租客名称', style: { width: '130px' } },
        },
        {
            tagName: 'Input',
            formConfig: { name: 'customerPhone' },
            attribute: { placeholder: '请输入租客手机号码', style: { width: '150px' } },
        },
        {
            tagName: 'Input',
            formConfig: { name: 'credentialNumber' },
            attribute: { placeholder: '请输入租客证件号码', style: { width: '150px' } },
        },
        {
            tagName: 'Input',
            formConfig: { name: 'roomNo' },
            attribute: { placeholder: '请输入房号', style: { width: '130px' } },
        },
    ];
    handleExportParams().merchantId ? data.splice(0, 1) : '';
    return data;
};

const columns = ({ handleSigning ,handleShowDetail }) => [
    {
        title: '账单周期',
        dataIndex: 'cycleIn'

    },
    {
        title: '小区/楼栋',
        dataIndex: 'buildingName'
    },
    {
        title: '房号',
        dataIndex: 'roomNo'
    },
    {
        title: '租客',
        dataIndex: 'customerName',
        render(text, record, index) {
            return <span>
                <div>{record.customerName}</div>
                <div>{record.customerPhone}</div>
            </span>
        }
    },
    {
        title: '应付金额',
        dataIndex: 'billMoneySum',
    },
    {
        title: '已付金额',
        dataIndex: 'receivedMoneySum',
    },
    {
        title: '操作',
        dataIndex: 'action',
        width: 80,
        render(text, record, index) {
            return (
                <React.Fragment>
                    <AuthButton authkey="c-3-3">
                      <span className="showClickDetail" onClick={() => { handleShowDetail(record.houseId,record.cycleIn,record.customerId,record.buildingName,record.roomNo,record.customerName) }} style={{ margin: '0 10px 0 0' }} >收据打印</span>
                    </AuthButton>
                </React.Fragment>

            )
        }
    }
];


// WEBPACK FOOTER //
// ./src/page/Bill/PrintReceipt/Receipt.js